'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddonRightStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.menu.item.addonRight,
      marginLeft = _theme$reactackle$com.marginLeft,
      marginRight = _theme$reactackle$com.marginRight;


  return (0, _styledComponents.css)(['margin:0 ', ' 0 ', ';'], (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.getValueString)(marginRight));
};

var AddonRightStyled = exports.AddonRightStyled = _styledComponents2.default.div.withConfig({
  displayName: 'AddonRightStyled'
})(['', ''], size);

AddonRightStyled.displayName = 'AddonRightStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/MenuItem/styles/AddonRightStyled.js
// module id = 738
// module chunks = 0